import MenuIcon from "./images/menu.svg";
import PlayIcon from "./images/play.svg";
import PauseIcon from "./images/pause.svg";
import StopIcon from "./images/stop.svg";
import Hat from "./images/hat.png";
import fetih from "./images/fetih.jpg";
import fetihDark from "./images/fetih-dark.png";
import istanbul from "./images/istanbul.jpg";
import empire from "./images/empire.jpg";

const audioFile = require("./audio/Buna-Er-Meydani-Derler.mp3");

export {
  MenuIcon,
  PauseIcon,
  PlayIcon,
  StopIcon,
  Hat,
  audioFile,
  istanbul,
  fetih,
  fetihDark,
  empire,
};
